import { useForm, FieldValues } from "react-hook-form";
import { toast } from "react-hot-toast";
import { Popup } from "components/UI/Popup/Popup";
import { FORM_FIELDS, RadioField } from "./helpers";
import { apiMain } from "services";
import "./style/GifPreferencePopup.scss";

interface IGifPreferencePopupProps {
  sexuality: string[];
  gifId?: string;
  onClose: () => void;
  isOpen: boolean;
}

export const GifPreferencePopup: React.FC<IGifPreferencePopupProps> = (props) => {
  const { gifId, onClose, isOpen, sexuality } = props;
  const { register, handleSubmit, formState, watch } = useForm();
  const watchGifPreference = watch("gifPreference");

  const onSubmit = async (data: FieldValues) => {
    try {
      if (gifId) {
        await apiMain.patchGif(gifId, {
          sexuality: data.gifPreference,
        });

        toast.success(
          `Saved the preference for the ${gifId}`,
          { duration: 5000 }
        );
      }

      onClose();
    } catch (err) {
      toast.error(
        `Error with saving preference for the ${gifId}`,
        { duration: 5000 }
      );
    }
  };

  const btnProps = {
    variant: 1,
    btnType: "submit",
    formId: "gif-preference-form",
    title: "Save",
    disabled: !watchGifPreference || formState.isSubmitting
  };

  return (
    <Popup
      title={`Define Preference for ${gifId} GIF`}
      isOpen={isOpen}
      onClose={onClose}
      popupClass="GifPreferencePopup"
      btnProps={btnProps}
    >
      <div className="GifPreferencePopup-Cnt">
        <form
          className="GifPreferencePopup-Form"
          onSubmit={handleSubmit(onSubmit)}
          id="gif-preference-form"
        >
          {FORM_FIELDS.map(({ label, name, type }: RadioField) => (
            <div className="PrefOption" key={name}>
              <label className="PrefOption-Label" htmlFor={name}>
                {label}
                <input
                  {...register("gifPreference")}
                  className="PrefOption-Input"
                  type={type}
                  value={name}
                  id={name}
                  defaultChecked={name === sexuality[0]}
                />
                <div className="PrefOption-Control"></div>
              </label>
            </div>
          ))}
        </form>
      </div>
    </Popup>
  );
};
